import { defineNuxtPlugin, useHead } from '#imports';
import { setConfig } from '@i22/td-longtail-vue-components';
import { openModal, closeModal } from '~/composables/modal';

// Set runtime env to component lib.
export default defineNuxtPlugin((nuxtApp) => {
  setConfig({
    cloudFront: {
      ...nuxtApp.$config.public.cloudFront,
      host: nuxtApp.$config.app.cdnURL.replace(/^(https?:\/\/|\/\/)/, ''),
    },
    imageOptimizer: nuxtApp.$img.getSizes,
    // @ts-ignore
    useHead,
    globalModal: {
      openModal,
      closeModal,
    },
  });
});
